import { notesReqApprovalActions, patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [notesReqApprovalActions.loadPdfSuccess]: (state, action) => {
        if (action.payload.entities.pdfs) {
            return { ...state, ...action.payload.entities.pdfs };
        } else {
            return { ...state };
        }
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.pdfsContainer.entities.pdfs) {
            return { ...state, ...action.payload.pdfsContainer.entities.pdfs };
        } else {
            return state;
        }
    },
    [notesReqApprovalActions.rejectFailure]: (state, action) => {
        log.error('Error loading PDF. noteId: ' + action.payload.noteId + ' error: ' + action.payload.error);
    },
    [patientActions.loadPdfSuccess]: (state, action) => {
        if (action.payload.entities.pdfs) {
            return { ...state, ...action.payload.entities.pdfs };
        } else {
            return { ...state };
        }
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },


})
